import { Button, Card, Form, Input, notification, Typography } from "antd";
import type { FormProps } from "antd";
import { Mail, Lock } from "lucide-react";

import { useState } from "react";
import { Link } from "react-router-dom";
import MicroticaLogo from "../../assets/logo-color.svg";
import { useSetPassword } from "./useSetPassword";

const { Title } = Typography;
type RequiredMark = FormProps['requiredMark'];

export default function SetPassword() {
    const [form] = Form.useForm();
    const { email, submit } = useSetPassword(({ title, description }) => notification.error({ message: title, description }));
    const [requiredMark] = useState<RequiredMark>('optional');

    return (
        <>
            <Link to="/">
                <img src={MicroticaLogo} style={{ height: "40px" }} alt="microtica" />
            </Link>
            <br />
            <Card style={{ width: "400px" }} bordered>
                <Card.Meta
                    title={<Title level={4}>Set new password</Title>}
                    description="You've been invited to Microtica. Set your password to get started."
                />
                <br />
                <Form
                    form={form}
                    layout="vertical"
                    requiredMark={requiredMark}
                    onFinish={(values: { password: string }) => submit(values.password)}
                >
                    <Form.Item
                        name="email"
                        label="Email"
                        required
                    >
                        <Input disabled placeholder="email" defaultValue={email} prefix={<Mail size={16} />} />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="New Password"
                        required
                        rules={[{ required: true, message: `Please input the new password!` }]}
                    >
                        <Input type="password" placeholder="password" prefix={<Lock size={16} />} />
                    </Form.Item>
                    <Button htmlType="submit" type="primary" block>
                        Get Started
                    </Button>
                    <small>By signing up to Microtica, you agree to our <a href="https://microtica.com/terms-of-service/" target="_blank" rel="noreferrer"> terms of service</a>.</small>
                </Form>
            </Card>
        </>
    )
}
